import { Pipe, PipeTransform } from '@angular/core';
import { ExhibitorsFilter } from './exhibitors-filter';
@Pipe({
  name: 'filters',
  pure: false,
})
export class ExhibitorsFiltersPipe implements PipeTransform {

  transform(exhibitors: ExhibitorEntry[], ...filters: ExhibitorsFilter[]): ExhibitorEntry[] {
    filters.forEach(f => {
      exhibitors = f.filter(exhibitors);
    });
    return exhibitors;
  }
}
